import React from 'react';

import { useCustomReactFlowState } from '../../context/reactflow-context';
import { FORM_FIELD_TYPES, FormField } from './form-field';

const SchemaEditor = ({ form, name = 'schema', id: _id }) => {
  const {
    control,
    formState: { errors },
  } = form;
  const { isReadOnly } = useCustomReactFlowState();

  return (
    <FormField
      controlId={`${name}`}
      label="schema"
      name={name}
      control={control}
      fieldComponentType={FORM_FIELD_TYPES.TEXTAREA}
      placeholder="Enter schema definition as text..."
      rows={10}
      error={errors?.[name]?.message}
      disabled={isReadOnly}
    />
  );
};

export default SchemaEditor;
